import React from "react";
import { useInView } from "react-intersection-observer";
import CountUp from "react-countup";
import bg3 from "../assets/bg3.jpeg";
const Assurance = () => {
  const [ref, inView] = useInView({
    triggerOnce: true, // Trigger animation only once
    threshold: 0.3, // Trigger when 30% of the section is visible
  });

  const data = [
    { number: 10, label: "YEARS OF TEAM EXPERIENCE", suffix: "+", id: 1 },
    { number: 28, label: "SQ. FT DELIVERED", suffix: "K+", id: 2 },
    { number: 24, label: "HAPPY CUSTOMERS", suffix: "+", id: 3 },
    { number: 3, label: "ONGOING PROJECTS", suffix: "+", id: 4 },
  ];

  return (
    <section
      id="assurance"
      ref={ref}
      className="h-screen relative bg-cover bg-center text-white"
      style={{
        backgroundImage: `url(${bg3})`, // Replace with your image URL
      }}
    >
      {/* Overlay for better readability */}
      <div className="absolute inset-0 bg-black bg-opacity-50"></div>

      {/* Content */}
      <div className="relative h-full flex flex-col items-center justify-center px-6">
        {/* Heading */}
        <h2 className="text-primary text-4xl font-bold mb-6">Assurance</h2>
        <p className="text-lg mb-12 max-w-2xl text-center">
          We take pride in delivering world-class projects with excellence and
          trust.
        </p>

        {/* Stats */}
        <div className="relative z-10 max-w-4xl w-full">
          {/* Top and Bottom Dividers */}
          <div className="grid grid-cols-2 gap-8 mb-6">
            {/* Top Row - Two Items */}
            <div className="flex flex-col items-center">
              {data.slice(0, 2).map((item) => (
                <div key={item.id} className="text-center mb-6">
                  <div className="text-5xl font-bold text-primary">
                    {inView && (
                      <CountUp
                        end={item.number}
                        duration={2}
                        suffix={item.suffix}
                      />
                    )}
                  </div>
                  <div className="text-lg mt-2">{item.label}</div>
                </div>
              ))}
            </div>

            {/* Bottom Row - Two Items */}
            <div className="flex flex-col items-center">
              {data.slice(2).map((item) => (
                <div key={item.id} className="text-center mb-6">
                  <div className="text-5xl font-bold text-primary">
                    {inView && (
                      <CountUp
                        end={item.number}
                        duration={2}
                        suffix={item.suffix}
                      />
                    )}
                  </div>
                  <div className="text-lg mt-2">{item.label}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Divider Line */}
          <div className="border-t-2 border-gray-300 mt-6 mb-6" />
        </div>
      </div>
    </section>
  );
};

export default Assurance;
